import { EnterpriseBuilderParametersType } from '@mews-commander/data-access';
import { EnterpriseBuilderProFormStep } from '../../types';
import { ExportFromStep } from './FormSteps/ExportFromStep';
import { ImportToStep } from './FormSteps/ImportToStep';
import { ExportSettingsStep } from './FormSteps/ExportSettingsStep';

interface EnterpriseCopyFormProps {
    onSubmit: () => void;
    onStepChange: (step: EnterpriseBuilderProFormStep) => void;
    currentStep: EnterpriseBuilderProFormStep;
    propertyType: EnterpriseBuilderParametersType;
}

export const EnterpriseBuilderProFormFields = ({
    onSubmit,
    onStepChange,
    currentStep,
    propertyType,
}: EnterpriseCopyFormProps) => (
    <>
        {currentStep === EnterpriseBuilderProFormStep.ExportFrom && <ExportFromStep onStepChange={onStepChange} />}
        {currentStep === EnterpriseBuilderProFormStep.ImportTo && (
            <ImportToStep onSubmit={onSubmit} propertyType={propertyType} onStepChange={onStepChange} />
        )}
        {currentStep === EnterpriseBuilderProFormStep.ExportSettings && (
            <ExportSettingsStep propertyType={propertyType} onSubmit={onSubmit} />
        )}
    </>
);
